import React, { useEffect, useState, useRef } from 'react';
import { FileSpreadsheet, Search, Loader2, Upload, Download, Check, X, List } from 'lucide-react';
import * as API from '../../../api';
import { PageTitle } from '../../../../_metronic/layout/core';
import { Modal } from 'react-bootstrap';
import UploadModal from '../../modals/UploadListModal';
import ConfirmModal from '../../modals/ConfirmModal';
import { GetPermissions } from '../../../modules/auth/core/Auth';
import { StatsCard } from '../StatsCard';
import { SearchInput } from '../SearchInput';
import { FilterBar } from '../FilterBar';
import { ListTable } from '../ListTable';
import * as XLSX from 'xlsx';

const CHANGE_TO: Record<string, string> = {
  "CENTRO NORTE": "CENTRO-NORTE",
  "CENTRO OESTE": "CENTRO-OESTE",
  "SAO PAULO": "SÃO PAULO",
};

type Props = {
  className?: string;
};

const ComparacaoBeneficioValor: React.FC<Props> = () => {
  const permissions = GetPermissions();
  const [message, setMessage] = useState('');
  const [confirmModal, showConfirmModal] = useState(false);
  const [selectedList, setSelectedList] = useState<any>(null);
  const [uploadModal, showUploadModal] = useState(false);
  const [uploadPromise, setUploadPromise] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchData, setSearchData] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [resultsData, setResultsData] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    Promise.all([
      getData()
    ]);
  }, []);

  useEffect(() => {
    showUploadModal(uploadPromise !== null);
  }, [uploadPromise]);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await API.getValidationAssociacaoPromoIDCupomDescID();
      console.log(response);
      setColumns(response.columns);
      console.log(response.data);
      setResultsData(response.data);
      setData(response.data);
    } catch (error) {
      console.error('Error loading lists:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Função para exportar os dados filtrados para XLSX
  const exportToXLSX = () => {
    if (!resultsData.length) return;

    // Monta os dados para a planilha como objetos
    			
    const dataForSheet = resultsData.map((item: any) => ({
      'ID Cupom': item[0],
      'Cupom': item[1],
      'Quantidade Cupom Desc IFC': item[2],
      'Validação Cupom Desc MGS': item[3],
      'Ação': item[2] >= 2 || item[3] != '' ? 'ATENÇÃO' : ''
    }));

    // Cria uma worksheet a partir dos dados
    const worksheet = XLSX.utils.json_to_sheet(dataForSheet);
    // Cria um novo workbook e adiciona a worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Validação PromoID e CupomDescID");

    // Gera o arquivo XLSX e inicia o download
    XLSX.writeFile(workbook, "validacao_promoid_cupomdescid.xlsx");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <PageTitle>Validação - Associação de PromoID a CupomDescID</PageTitle>
            
              <div className="flex items-center gap-4">
                
                {/* Botão para exportar para XLSX */}
                <button
                  onClick={exportToXLSX}
                  className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  <FileSpreadsheet className="w-5 h-5 mr-2" />
                  Exportar Planilha
                </button>
                
              </div>
            
          </div>

          {!isLoading && (
            <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              <StatsCard
                title="Total de Resultados"
                value={data.length}
                description="Resultados"
                icon={<List className="w-6 h-6" />}
              />
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12">
              <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
              <p className="mt-4 text-gray-500">Carregando dados...</p>
            </div>
          ) : !resultsData.length ? (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="bg-gray-100 rounded-full p-3">
                <List className="w-8 h-8 text-gray-400" />
              </div>
              <p className="mt-4 text-gray-500">Nenhuma lista encontrada</p>
            </div>
          ) : (
            <ListTable
              data={resultsData}
              columns={columns}
              rule={
                [
                  {col:2, value:2, func:'>='}, 
                  {col:3, value:'', func:'!='}
                ]}
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default ComparacaoBeneficioValor;
